export type AdminMfaApiConfig = {
  baseURL: string;
  timeout: number;
  withCredentials: boolean;
};

export const buildAdminMfaApiConfig = (authServerUrl: string): AdminMfaApiConfig => ({
  baseURL: authServerUrl.replace(/\/+$/, ''),
  timeout: 30000,
  withCredentials: true,
});
